import React from 'react';

/**
 * This file and its references should be deleted when migrating to skylab 2
 */

const SKYLAB_VERSION = '2.45.0';

const withSkylabVersioning = ( SkylabVersionAwareComponent, supportedVersions=[] ) => {
  return (props={}) => {
    if(!SKYLAB_VERSION || supportedVersions.indexOf(SKYLAB_VERSION) !== -1) {
      return <SkylabVersionAwareComponent {...props} />;
    } else {
      return <></>;
    }
  };
};

const AlertCloseButton = function(props={}) {
  const closeHandler = (event) => {
    if(typeof props.onClose === 'function') {
      props.onClose();
    }
  }
  return (
    <button className="link s-alert-dismiss absolute" aria-label="Close" onClick={closeHandler}>
      <s-icon name="close" ></s-icon>
    </button>
  );
};

export const SDashAlertCloseButton = withSkylabVersioning(AlertCloseButton, [SKYLAB_VERSION]);

const FallbackComponents = {
  SDashAlertCloseButton: SDashAlertCloseButton
};

export default FallbackComponents;
